import { focusAtom } from 'jotai-optics';

import { Routes } from 'src/Routes.constants';

import { ESIM_INITIAL_FILTERS } from 'src/products/esim/constants/esim';
import { createPaginationAtoms } from './utils/filtersFactory';

import { atomWithSerachParams } from '../components/atomWithSerachParams';
import { paginatedFiltersAtom } from '../components/paginatedFiltersAtom';
import { atom } from 'jotai';
import { cleanDefaultValuesURLSearchParams } from 'src/common/utils/urlSearchParamsUtils';
import { mapURLSearchParamsToESimFilters } from 'src/products/esim/Inventory/Filters/SearchParams/constants/esimSearchParams';

const initialESimFiltersAtom = atomWithSerachParams({
  route: Routes.esim,
  urlSearchParamsMapperFn: mapURLSearchParamsToESimFilters,
  initialFilters: ESIM_INITIAL_FILTERS,
});

const { rowsPerPageFilterAtom, pageFilterAtom } = createPaginationAtoms();
export const esimRowsPerPageFilterAtom = rowsPerPageFilterAtom;
export const esimPageFilterAtom = pageFilterAtom;

export const esimFiltersAtom = paginatedFiltersAtom({
  initialFiltersAtom: initialESimFiltersAtom,
  pageAtom: pageFilterAtom,
  initialFilters: ESIM_INITIAL_FILTERS,
});

export const searchTextFilterAtom = focusAtom(esimFiltersAtom, (optic) => optic.prop('searchText'));

export const esimProductsUrlParamsAtom = atom(
  (get) => {
    const cleanedFiltersValues = cleanDefaultValuesURLSearchParams(
      get(esimFiltersAtom),
      ESIM_INITIAL_FILTERS,
    );

    const searchParams = new URLSearchParams({
      ...cleanedFiltersValues,
    });

    return searchParams;
  },
  (_, set, urlSearchParams: URLSearchParams) => {
    const filters = mapURLSearchParamsToESimFilters(urlSearchParams);

    set(esimFiltersAtom, filters);
  },
);
